import { AgreementTermModification } from './agreement-term-modification.model';
import { AgreementEndMileageModification } from './agreement-end-mileage-modification.model';

export class FutureValuesSettings {
    outputAllMonths: boolean;
    outputForSpecificMonth: boolean;
    specificMonthToOutput: number;
    agreementTermModification: AgreementTermModification;
    agreementEndMileageModification: AgreementEndMileageModification;
}



// WEBPACK FOOTER //
// ./src/app/report/models/future-values-settings.model.ts